module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_3_3_5.c3429d0c.png";